




























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class AccountDetailField extends Vue {
  @Prop({ default: false }) errorValue!: boolean;

  @Prop({ default: 'Title' }) title!: string;

  @Prop({ default: 'Tooltip' }) tooltip!: string;

  @Prop({ default: 'Value' }) value!: string;

  @Prop({
    default: () => (val: any) => val,
  })
  valueFormatter!: Function;
}
